import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { DocumentsData } from "@/actions/ssr/documents/getDocumentsSSR";

const FALLBACK: DocumentsData = {
  stats: { total: 0, valid: 0, expiringSoon: 0, expired: 0 },
  documents: [],
};

interface DocumentsState {
  data: DocumentsData;
  clientFetched: boolean;
}

const initialState: DocumentsState = { data: FALLBACK, clientFetched: false };

const documentsSlice = createSlice({
  name: "staffDocuments",
  initialState,
  reducers: {
    setStaffDocumentsFromSSR(state, action: PayloadAction<DocumentsData>) {
      if (state.clientFetched) return;
      state.data = action.payload;
    },
    setStaffDocuments(state, action: PayloadAction<DocumentsData>) {
      state.clientFetched = true;
      state.data = action.payload;
    },
  },
});

export const { setStaffDocumentsFromSSR, setStaffDocuments } =
  documentsSlice.actions;
export default documentsSlice.reducer;
